export default "__VITE_ASSET__1db4586d__"